import React, { useMemo } from "react";
import BenefitText from "./benefitText";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";

const imageVariants = {
  offscreen: {
    opacity: 0,
    scale: 1.1,
    y: 100
  },
  onscreen: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.3,
      delay: 0.45
    }
  }
}

const Benefit = ({
  number, 
  title,
  text, 
  image,
  textLeft,
  bulletList
}) => {

  const isMobile = useMediaQuery({ query: '(max-width: 993px)' });

  const components = useMemo(() => {

    var className = "row benefit-item";
    if(!textLeft)
      className += " benefit-item-text-right";

    return (
      <div className={className}>
        <div className="col-lg-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          { textLeft ? 
            <BenefitText 
              number={number} 
              title={title}
              text={text} 
              bulletList={bulletList}
            />
            :
            <motion.div className="benefit-image" variants={imageVariants}>
              <div className="benefit-inner-image">
                {image}
              </div>
            </motion.div>
          }
        </div>
        <div className="col-lg-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          { !textLeft ? 
            <BenefitText 
              number={number} 
              title={title}
              text={text} 
              bulletList={bulletList}
            />
            :
            <motion.div className="benefit-image" variants={imageVariants}>
              <div className="benefit-inner-image">
                {image}
              </div>
            </motion.div>
          }
        </div>
      </div>
    );
  }, []);

  return(
    <motion.div
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true, amount: isMobile ? 0.2 : 0.5 }}
    >
      {components}
    </motion.div>
  );
};

export default Benefit;